module.exports = __webpack_public_path__ + "static/img/10.f90080ed.png";